/**
 * SYM-6203. What to say after deleting ads.
 *
 * Deleting several ads at once sent one request per ad, and each one raised
 * its own message saying "Your ads have been successfully deleted". Three ads
 * meant three stacked messages, all in the plural, none of them saying three.
 *
 * The deletion stays one request per ad -- that is what the server offers --
 * but the customer is told once, with the number they actually deleted, and
 * told plainly when some of them did not go.
 */

export interface AdDeletionOutcome {
  /** How many ads were deleted. */
  deleted: number;
  /** How many were asked for and did not go. */
  failed: number;
}

export interface AdDeletionMessage {
  ok: boolean;
  text: string;
}

export function adDeletionMessage({
  deleted,
  failed,
}: AdDeletionOutcome): AdDeletionMessage {
  if (failed > 0 && deleted === 0) {
    return {
      ok: false,
      text:
        failed === 1
          ? 'Your ad could not be deleted. Please try again.'
          : `None of the ${failed} ads could be deleted. Please try again.`,
    };
  }

  if (failed > 0) {
    return {
      ok: false,
      text: `${deleted} of the ${
        deleted + failed
      } ads were deleted. Please try the rest again.`,
    };
  }

  return {
    ok: true,
    text:
      deleted === 1
        ? 'Your ad has been deleted'
        : `${deleted} ads have been deleted`,
  };
}
